import {
  GET_ACADEMIC_CYCLE_CONFIGS,
  GET_ACADEMIC_CYCLE_CONFIGS_FAIL,
  GET_ACADEMIC_CYCLE_CONFIGS_SUCCESS,
  ADD_NEW_ACADEMIC_CYCLE_CONFIG,
  ADD_ACADEMIC_CYCLE_CONFIG_SUCCESS,
  ADD_ACADEMIC_CYCLE_CONFIG_FAIL,
  UPDATE_ACADEMIC_CYCLE_CONFIG,
  UPDATE_ACADEMIC_CYCLE_CONFIG_SUCCESS,
  UPDATE_ACADEMIC_CYCLE_CONFIG_FAIL,
  DELETE_ACADEMIC_CYCLE_CONFIG,
  DELETE_ACADEMIC_CYCLE_CONFIG_SUCCESS,
  DELETE_ACADEMIC_CYCLE_CONFIG_FAIL,
  
} from "./actionTypes";

export const getAcademicCycleConfigs = () => ({
  type: GET_ACADEMIC_CYCLE_CONFIGS,
})

export const getAcademicCycleConfigsSuccess = academicCycleConfigs => ({
  type: GET_ACADEMIC_CYCLE_CONFIGS_SUCCESS,
  payload: academicCycleConfigs,
})

export const getAcademicCycleConfigsFail = error => ({
  type: GET_ACADEMIC_CYCLE_CONFIGS_FAIL,
  payload: error,
})

export const addNewAcademicCycleConfig = data => ({
  type: ADD_NEW_ACADEMIC_CYCLE_CONFIG,
  payload: data,
})

export const addAcademicCycleConfigSuccess = academicCycleConfig => ({
  type: ADD_ACADEMIC_CYCLE_CONFIG_SUCCESS,
  payload: academicCycleConfig,
})

export const addAcademicCycleConfigFail = error => ({
  type: ADD_ACADEMIC_CYCLE_CONFIG_FAIL,
  payload: error,
})

export const updateAcademicCycleConfig = academicCycleConfig => ({
  type: UPDATE_ACADEMIC_CYCLE_CONFIG,
  payload: academicCycleConfig,
})

export const updateAcademicCycleConfigSuccess = academicCycleConfig => ({
  type: UPDATE_ACADEMIC_CYCLE_CONFIG_SUCCESS,
  payload: academicCycleConfig,
})

export const updateAcademicCycleConfigFail = error => ({
  type: UPDATE_ACADEMIC_CYCLE_CONFIG_FAIL,
  payload: error,
})

export const deleteAcademicCycleConfig = data => ({
  type: DELETE_ACADEMIC_CYCLE_CONFIG,
  payload: data,
})

export const deleteAcademicCycleConfigSuccess = data => ({
  type: DELETE_ACADEMIC_CYCLE_CONFIG_SUCCESS,
  payload: data,
})

export const deleteAcademicCycleConfigFail = error => ({
  type: DELETE_ACADEMIC_CYCLE_CONFIG_FAIL,
  payload: error,
})

